AppTabs.createTab( {
name: 'equis-chemicals',
icon: 'list-alt',
text: 'EQUIS Chemicals',
create: function(init) {
	'use strict'

	init.setDataTableArgs( {

		tableId: 		'#data-table-equis-chemicals',

		readTableName: 	'tblEquisChemicals',
		editTableName: 	'tblEquisChemicals',
		primaryKey: 	'EquisChemicalID',

		hasColumnFilters: 	true,
		canSearch: 			true,
		canSort:			true,
		paging:				false,

		actionData:			'datatable',
		actionAutofill: 	'datatable_autofill',
		actionCreate:		'datatable_create',
		actionEdit:			'datatable_edit',
		actionRemove:		'datatable_remove',

		fields: [
			{
				label: 		'Analyte',
				columnName: 'AnalyteID',
				isEditable: true,
				order: 		'asc',
				type: 		'maybe-analyte',
			},
			{
				label: 		'Test',
				columnName: 'TestID',
				type: 		'maybe-test',
				isEditable: true,
				order: 		'asc',
			},
			{
				label: 		'cas_rn',
				columnName: 'cas_rn',
				isEditable: true,
			},
			{
				label: 		'chemical_name',
				columnName: 'chemical_name',
				isEditable: true,
			},
			{
				label: 		'sort_order',
				columnName: 'sort_order',
				isEditable: true,
			},
			{
				label: 		'analyte_type',
				columnName: 'analyte_type',
				isEditable: true,
			},
			{
				label: 		'organic_yn',
				columnName: 'organic_yn',
				isEditable: true,
				type: 'select',
				options: [
					{ label: 'N', value: 'N' },
					{ label: 'Y', value: 'Y' },
				],
			},
			{
				label: 		'anl_short_name',
				columnName: 'anl_short_name',
				isEditable: true,
			},
			{
				label: 		'analysis_location',
				columnName: 'analysis_location',
				isEditable: true,
			},
			{
				label: 		'remark',
				columnName: 'remark',
				isEditable: true,
			},
		],

	} );
}

} );
